import React from 'react';
import {
  Container,
  Typography,
  Box,
  Breadcrumbs,
  Paper,
  Grid,
  makeStyles,
  createStyles,
} from '@material-ui/core';
import { MembershipTrainerData } from '.';
import { Link } from 'gatsby-theme-material-ui';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { TrainerCard } from '../../features/trainers-list/trainer-card';
import { nameRepresentation } from '../../utils/text-formatting';
import { MembershipForm } from '../../features/membership-form.tsx/membership-form';

interface Props {
  trainerData: MembershipTrainerData;
}

const useStyles = makeStyles(({ spacing }) =>
  createStyles({
    paper: {
      padding: spacing(6),
    },
  })
);

export const TrainerMembershipDesktop: React.FC<Props> = ({ trainerData }) => {
  const name = nameRepresentation(
    trainerData.first_name,
    trainerData.last_name
  );
  const classes = useStyles();
  return (
    <Container maxWidth="lg">
      <Box mt={5} mb={5}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link color="inherit" to="/trainers">
            Trainers
          </Link>
          <Link color="inherit" to={`/trainers/${trainerData._id}`}>
            {name}
          </Link>
          <Typography color="textPrimary">Membership</Typography>
        </Breadcrumbs>
      </Box>
      <Paper className={classes.paper}>
        <Container maxWidth="md">
          <Grid container spacing={2}>
            <Grid item sm={5}>
              <TrainerCard
                variant="outlined"
                name={name}
                price={trainerData.price}
                availableSpots={trainerData.available_spots}
                bio={trainerData.bio}
                profilePicture={trainerData.profile_pic_url}
                coverImage={trainerData.cover_image_url}
              />
            </Grid>
            <Grid item sm={6}>
              <Typography variant="h5">Start for Free</Typography>
              <Box mt={7} />
              <MembershipForm trainerData={trainerData} />
            </Grid>
          </Grid>
        </Container>
      </Paper>
    </Container>
  );
};
